import { LocalStorage, SessionStorage, LOCAL_KEYS } from "./storages"

const loadJS = ({ id, src, callback }) => {
  // Use callback if the script element is existed
  if (document.getElementById(id)) {
    callback()
    return
  }

  // Create a async script element
  const script = document.createElement("script")
  script.id = id
  script.src = src
  script.async = true

  // Append to body
  const body = document.querySelector("body") || null
  if (body) {
    body.appendChild(script)
  }
}

export const getAccessToken = () => {
  const user =
    LocalStorage.get(LOCAL_KEYS.PROFILE, SessionStorage.get(LOCAL_KEYS.PROFILE, {}))

  return user?.access_token || null
}

const truncate = str => {
  if (str.length > 50) {
    return `${str.slice(0, 50)}...`
  }
  return str
}

export const fullName = (user, unknownName = "Anonymous", extend = "") => {
  const { first_name: firstName = "", last_name: lastName = "" } = user || {}
  if (!firstName && !lastName) {
    return unknownName + extend
  }
  if (!firstName) {
    return truncate(lastName) + extend
  }
  if (!lastName) {
    return truncate(firstName) + extend
  }
  return truncate(`${firstName} ${lastName}`) + extend
}

const hexToRGB = (hex, alpha) => {
  if (!hex) return null
  const r = Number.parseInt(hex.slice(1, 3), 16)
  const g = Number.parseInt(hex.slice(3, 5), 16)
  const b = Number.parseInt(hex.slice(5, 7), 16)

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  }
  return `rgb(${r}, ${g}, ${b})`
}

export const formatHtmlBreak = text => {
  if (!text) return ""
  return text
    .replace(/\\n/g, "<br />")
    .replace(/<p data-f-id="pbf".*?<\/p>/g, "")
    .replace(
      /<p style="text-align:center;">Powered by <a href="https:\/\/www.froala.com\/wysiwyg-editor\?pb=1">Froala Editor<\/a><\/p>/g,
      ""
    )
}

export const removeNullParams = params => {
  return Object.keys(params).reduce((object, key) => {
    if (
      params?.[key] !== null &&
      params?.[key] !== undefined &&
      params?.[key] !== ""
    ) {
      object[key] = params[key]
    }
    return object
  }, {})
}

const formatCurrency = (value, currency = "VND") => {
  if (!value) return "0"
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency
  }).format(value)
}

// 10000 -> 1,000
export const formatNumberCurrency = value => {
  if (!value) return "0"
  return value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}

// format 1000 -> 1,000đ
export const formatPrice = price => {
  if (!price) return "0đ"
  return `${formatNumberCurrency(price)}đ`
}

export const replaceDomain = (url, newDomain) => {
  // Create a URL object from the input URL
  const parsedUrl = new URL(url);
  
  // Replace the hostname with the new domain
  parsedUrl.hostname = newDomain;

  // Return the updated URL as a string
  return parsedUrl.toString();
}